// extracted by mini-css-extract-plugin
export default {"inputs":"auth_inputs__Pz5EC","LoginButton":"auth_LoginButton__lFGib","Iconcenter":"auth_Iconcenter__rIxdo"};